<template>
  <EEntity v-if="!isDesktopUp" v-bind="{ ...$attrs, ...$props }" v-on="$listeners">
    <slot />
  </EEntity>
</template>

<script>
import screen from '~~/common/vue/mixins/screen';
import EEntity from './entity';

export default {
  name: 'EEntityMainline',
  components: {
    EEntity,
  },
  mixins: [screen],
  props: EEntity.props,
};
</script>
